import config from "@/config/env";

export const analyticsApi = {
  getMetrics: async (range: string): Promise<any> => {
    const res = await fetch(`${config.api.backendUrl}/api/v1/analytics/metrics?range=${range}`);
    return res.json();
  },
  getTrends: async (range: string): Promise<any> => {
    const res = await fetch(`${config.api.backendUrl}/api/v1/analytics/trends?range=${range}`);
    return res.json();
  },
};
